<template lang="pug">
    b-container
        b-row
            b-col(class="d-none d-lg-block")
              category                
            b-col
              template(v-for="(proj, year, index) in projects")
                figure(class="figure img-fluid")
                  img(:src="getImageSource(proj)", class="figure-img img-fluid rounded")
                  figcaption(class="figure-caption") {{proj.imageCap}}
</template>
<script>
import category from "../components/CategoryFilter.vue";

export default {
  components: {
    category
  },
  data() {
    return {
      projects: [
        {
          time: "2019",
          imageSource: "catskill_creek.jpg",
          imageCap: "Catskill Creek"
        },
        // {
        //   time: "2017-2019",
        //   imageSource: "yangtzi_river.png",
        //   imageCap: "Yangtzi River Project"
        // },
        {
          time: "2016",
          imageSource: "hong_kong_2016_3.png",
          imageCap: "To see Hong Kong Island from Kowloo July 17-18 2016"
        },
        {
          time: "2016",
          imageSource: "hong_kong_2016_2.png",
          imageCap: "Hong Kong 2016 2"
        },
        {
          time: "2016",
          imageSource: "hong_kong_2016.png",
          imageCap: "Hong Kong 2016"
        },
        {
          time: "2015",
          imageSource: "hong_kong_2015.png",
          imageCap: "Hong Kong 2015"
        },
        {
          time: "2015",
          imageSource: "hong_kong_2015_2.png",
          imageCap: "Hong Kong 2015 2"
        },
        {
          time: "2015",
          imageSource: "hong_kong_2015_3.png",
          imageCap: "Hong Kong 2015 3"
        },
        {
          time: "2014",
          imageSource: "hong_kong_2014.png",
          imageCap: "Hong Kong 2014"
        },
        {
          time: "2013",
          imageSource: "shanghai_tower.png",
          imageCap: "Shanghai tower"
        },
        {
          time: "2013",
          imageSource: "yan_an_road.png",
          imageCap: "Shanghai Yan'an Road 2-3 July 2013"
        },
        {
          time: "2013",
          imageSource: "beijing_cbd.png",
          imageCap: "Beijing CBD 8-9 June 2013"
        },
        {
          time: "2013",
          imageSource: "yangtze_river_2013.png",
          imageCap: "The Yangtze River 7-8 May 2013"
        },
        {
          time: "2011",
          imageSource: "guilin.png",
          imageCap: "Gui Lin"
        },
        { time: "2011", imageSource: "zenspace.png", imageCap: "Zen Space" },
        {
          time: "2010",
          imageSource: "fangcaodi.jpg",
          imageCap: "New Beijing: Qiaofu Building, August 16-30 2010"
        },
        {
          time: "2009",
          imageSource: "central_park.png",
          imageCap: "Central Park Feb 21 2009"
        },
        {
          time: "2008",
          imageSource: "birds_nest.png",
          imageCap: "Bird's Nest Stadium, Feb 3 2008"
        },
        {
          time: "2008",
          imageSource: "new_shanghai.png",
          imageCap: "Shanghai, Aug 8 2008"
        },
        {
          time: "2008",
          imageSource: "911.png",
          imageCap: "9/11 Construction Site, Sep 16 2008"
        },
        {
          time: "2008",
          imageSource: "time_square.png",
          imageCap: "Time square, Oct 3 2008"
        },
        {
          time: "2007",
          imageSource: "border.jpg",
          imageCap: "Border, San Diego, Dec 12 2007"
        },
        {
          time: "2007",
          imageSource: "windmill.jpg",
          imageCap: "Border, San Diego, Dec 11 2007"
        },
        {
          time: "2007",
          imageSource: "shenzhen.png",
          imageCap: "Shenzhen, Apr 4 2007"
        },
        {
          time: "2007",
          imageSource: "shenzhen_2.png",
          imageCap: "Shenzhen, Apr 4 2007"
        },
        {
          time: "2007",
          imageSource: "hong_kong_2007.png",
          imageCap: "Hong Kong, Sep 28 2007"
        },
        {
          time: "2007",
          imageSource: "new_shanghai_2.jpg",
          imageCap: "New Shanghai,Sep 14 2007"
        },
        {
          time: "2007",
          imageSource: "new_beijing.png",
          imageCap: "New Beijing"
        },
        {
          time: "2007",
          imageSource: "new_beijing_2.jpg",
          imageCap: "New Beijing 2"
        },
        {
          time: "2007",
          imageSource: "tiananmen.jpg",
          imageCap: "Tian An Men, Sep 4 2007"
        },
        {
          time: "2007",
          imageSource: "wangjing_1.jpg",
          imageCap: "Wangjing 1"
        },
        {
          time: "2007",
          imageSource: "wangjing_2.jpg",
          imageCap: "Wangjing 2"
        },
        {
          time: "2007",
          imageSource: "new_cctv.jpg",
          imageCap: "New CCTV, Apr 4 2007"
        },
        {
          time: "2007",
          imageSource: "national_center_for_performing_arts.png",
          imageCap: "National Center for Performing Arts, Apr 4 2007"
        },
        {
          time: "2007",
          imageSource: "las_vegas.png",
          imageCap: "Las Vegas, Apr 4 2007"
        },
        {
          time: "2007",
          imageSource: "las_vegas_2.jpg",
          imageCap: "Red Rock, Las Vegas"
        },
        {
          time: "2007",
          imageSource: "las_vegas_3.jpg",
          imageCap: "Las Vegas"
        },

        {
          time: "2006",
          imageSource: "sf_alctraz.png",
          imageCap: "A view of  San Francisco through the Alcatraz, Oct 16 2006"
        },
        {
          time: "2006",
          imageSource: "donner_pass.png",
          imageCap: "Donner Pass, Oct 9 2006"
        },
        {
          time: "2006",
          imageSource: "hollywood.jpg",
          imageCap: "Hollywood sign, Oct 3 2006"
        },
        {
          time: "2005",
          imageSource: "everest_2.jpg",
          imageCap: "Himalaya: the Mount Everest 884.43, Oct 9 2005"
        },
        {
          time: "2005",
          imageSource: "everest.jpg",
          imageCap: "The Everest, Himalayas, Nov 10 2005"
        },
        {
          time: "2004",
          imageSource: "shanghai_early.jpg",
          imageCap: "Shanghai, Oct 21-22 2004"
        },
        {
          time: "2002",
          imageSource: "great_wall.jpg",
          imageCap: "Great Wall, Apr 28 2002"
        }
      ]
    };
  },
  methods: {
    getImageSource(project) {
      return require("../assets/" + project.imageSource);
    }
  }
};
</script>>